import { render, staticRenderFns } from "./PeerGroupList.vue?vue&type=template&id=294f5a2e&"
import script from "./PeerGroupList.vue?vue&type=script&lang=ts&"
export * from "./PeerGroupList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports